




















































































































































































































































































































































































































































































































































































































































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { appModule } from "@/store/modules/app";
import { storeRefFaskes } from "@/store/modules/bridgingVclaim/RefFaskes";
import { storeRefPoli } from "@/store/modules/bridgingVclaim/RefPoli";
import { storeRefDokter } from "@/store/modules/bridgingVclaim/RefDokter";
import { storeRefDiagnosa } from "@/store/modules/bridgingVclaim/RefDiagnosa";
import { storeSEP } from "@/store/modules/bridgingVclaim/SEP";
import SEP from "@/services/bridgingVclaim/SEP";
import InputSRK from "@/pages/PendaftaranPage/InputSRK.vue";

import moment from "moment";
import UpdateTanggalPulangModal from "./UpdateTanggalPulangModal.vue";
// import { formatToYMDDate } from "@/utility/DateUtils";
import storePeserta from "@/store/modules/bridgingVclaim/Peserta";
import ReferensiSvc from "@/services/bridgingVclaim/Referensi";

@Component({
  components: {
    InputSRK,
    UpdateTanggalPulangModal
  }
})
export default class InputSEP extends Vue {
  @Prop() itemsAsalRujukan: Array<any>;
  @Prop() itemsJenisPelayanan: Array<any>;
  @Prop() itemsKelas: Array<any>;
  @Prop() itemsNaik: Array<any>;
  @Prop() itemsYaTidak: Array<any>;
  @Prop() itemsPembiayaan: Array<any>;
  @Prop() responseVclaim: Array<any>;
  @Prop() itemsTujuan: Array<any>;
  @Prop() itemsFlagProsedur: Array<any>;
  @Prop() itemsPenunjang: Array<any>;
  @Prop() itemsAsesmen: Array<any>;
  @Prop() itemsKll: Array<any>;
  @Prop() itemsSuplesi: Array<any>;

  showDpjpSKDP = true;
  showPembiayaan = true;
  showPJNaikKelas = true;
  showNaik = true;
  tglShowSEP = false;
  tglShowRujukan = false;
  tglShowKll = false;
  cm = "";
  kodeppk = "1205R001";
  ppk = "1205R001 - RSUD Panembahan Senopati";
  asalRujukan = "";
  ppkRujukan = "";
  diagnosaAwal = "";
  poliTujuan = "";
  dpjpSep = "";
  skdpspri = "";
  dpjpSkdpSpri = "";
  jenisPelayanan = "";
  kelas = "";
  naik = "";
  pembiayaan = "";
  pjNaikKelas = "";
  eksekutif = "0";
  cob = "0";
  katarak = "0";
  catatan = "";
  tglRujukan = "";
  tglSEP = "";
  today = new Date().toISOString().substr(0, 10);
  saving = false;
  printing = false;
  noKartu = "";
  noRujukan = "";
  tujuan = "0";
  flagProsedur = "";
  penunjang = "";
  asesmen = "";
  kll = "0";
  tglKll = "";
  keterangan = "";
  suplesi = "";
  noSEPSuplesi = "";
  prov = "";
  kab = "";
  kec = "";
  noSEP = "";
  nama = "";
  telp = "";
  user = "user ws";

  tglPulangModalShowed = false;
  enabledPenunjangItem = [];

  mounted() {
    ReferensiSvc.getPropinsi().then(item => {
      this.itemsProv = item.data;
    });
  }

  itemsProv = [];

  itemsKab = [];

  itemsKec = [];

  disableKabField = true;
  disableKecField = true;

  get sep() {
    return storeSEP.sep;
  }

  get listPPKRujukan() {
    return storeRefFaskes.refFaskes;
  }
  get listPoliTujuan() {
    return storeRefPoli.refPoli;
  }
  get listDpjpSep() {
    return storeRefDokter.refDokter;
  }
  get listDiagnosaAwal() {
    return storeRefDiagnosa.refDiagnosa;
  }

  get dataSEP() {
    return {
      request: {
        t_sep: {
          noKartu: this.noKartu,
          tglSep: this.tglSEP,
          ppkPelayanan: this.kodeppk,
          jnsPelayanan: this.jenisPelayanan,
          klsRawat: {
            klsRawatHak: this.kelas,
            klsRawatNaik: this.naik,
            pembiayaan: this.pembiayaan,
            penanggungJawab: this.pjNaikKelas
          },
          noMR: this.cm,
          nama: this.nama,
          rujukan: {
            asalRujukan: this.asalRujukan,
            tglRujukan: this.tglRujukan,
            noRujukan: this.noRujukan,
            ppkRujukan: this.ppkRujukan
          },
          catatan: this.catatan,
          diagAwal: this.diagnosaAwal,
          poli: { tujuan: this.poliTujuan, eksekutif: this.eksekutif },
          cob: { cob: this.cob },
          katarak: { katarak: this.katarak },
          jaminan: {
            lakaLantas: this.kll,
            penjamin: {
              tglKejadian: this.tglKll,
              keterangan: this.keterangan,
              suplesi: {
                suplesi: this.suplesi,
                noSepSuplesi: this.noSEPSuplesi,
                lokasiLaka: {
                  kdPropinsi: this.prov,
                  kdKabupaten: this.kab,
                  kdKecamatan: this.kec
                }
              }
            }
          },
          tujuanKunj: this.tujuan,
          flagProcedure: this.flagProsedur,
          kdPenunjang: this.penunjang,
          assesmentPel: this.asesmen,
          skdp: { noSurat: this.skdpspri, kodeDPJP: this.dpjpSkdpSpri },
          dpjpLayan: this.dpjpSep,
          noTelp: this.telp,
          user: this.user
        }
      }
    };
  }
  get dataEditSEP() {
    return {
      request: {
        t_sep: {
          noSep: this.noSEP,
          klsRawat: {
            klsRawatHak: this.kelas,
            klsRawatNaik: this.naik,
            pembiayaan: this.pembiayaan,
            penanggungJawab: this.pjNaikKelas
          },
          noMR: this.cm,
          catatan: this.catatan,
          diagAwal: this.diagnosaAwal,
          poli: { tujuan: this.poliTujuan, eksekutif: this.eksekutif },
          cob: { cob: this.cob },
          katarak: { katarak: this.katarak },
          jaminan: {
            lakaLantas: this.kll,
            penjamin: {
              tglKejadian: this.tglKll,
              keterangan: this.keterangan,
              suplesi: {
                suplesi: this.suplesi,
                noSepSuplesi: this.noSEPSuplesi,
                lokasiLaka: {
                  kdPropinsi: this.prov,
                  kdKabupaten: this.kab,
                  kdKecamatan: this.kec
                }
              }
            }
          },
          dpjpLayan: this.dpjpSep,
          noTelp: this.telp,
          user: "Coba Ws"
        }
      }
    };
  }

  get peserta() {
    return storePeserta.peserta;
  }

  get showAsesmenPelayanan() {
    this.flagProsedur = "";
    this.penunjang = "";
    return ["0", "2"].includes(this.tujuan);
  }

  get showProsedurFields() {
    this.asesmen = "";
    return ["1"].includes(this.tujuan);
  }

  get penunjangItemsWithDisable() {
    return this.itemsPenunjang.map(item => {
      return {
        ...item,
        disabled: !this.enabledPenunjangItem.includes(item.id)
      };
    });
  }

  @Watch("peserta", { deep: true })
  changePeserta(pst) {
    if (pst) {
      this.cm = pst.mr.noMR;
      this.kelas = pst.hakKelas.kode;
      this.noKartu = pst.noKartu;
      this.telp = this.peserta.mr.noTelepon;
    } else {
      this.clear();
    }
  }

  @Watch("kelas")
  cekKelas(val) {
    if (val) {
      this.showNaik = false;
    } else {
      this.showNaik = true;
      this.naik = "";
    }
  }

  @Watch("skdpspri")
  cekSKDPSPRI(val) {
    if (val) {
      this.showDpjpSKDP = false;
    } else {
      this.showDpjpSKDP = true;
      this.dpjpSkdpSpri = "";
    }
  }

  @Watch("naik")
  cekNaik(val) {
    if (val) {
      this.showPembiayaan = false;
    } else {
      this.showPembiayaan = true;
      this.pembiayaan = "";
    }
  }

  @Watch("pembiayaan")
  cekPembiayaan(val) {
    if (val) {
      this.showPJNaikKelas = false;
    } else {
      this.showPJNaikKelas = true;
      this.pjNaikKelas = "";
    }
  }

  @Watch("prov")
  cekProv(val) {
    this.kec = "";
    this.kab = "";
    this.itemsKab = [];
    this.itemsKec = [];

    if (val) {
      ReferensiSvc.getKabupaten(val).then(item => {
        this.itemsKab = item.data;
      });

      this.disableKabField = false;
    } else {
      this.disableKabField = true;
    }
  }

  @Watch("kab")
  cekKab(val) {
    this.kec = "";
    this.itemsKec = [];

    if (val) {
      ReferensiSvc.getKecamatan(val).then(item => {
        this.itemsKec = item.data;
      });

      this.disableKecField = false;
    } else {
      this.disableKecField = true;
    }
  }

  @Watch("responseVclaim")
  changeresponseVclaim(val) {
    if (val) {
      this.ppkRujukan = val.rujukan.provPerujuk.kode;
      this.diagnosaAwal = val.rujukan.diagnosa.kode;
      this.poliTujuan = val.rujukan.poliRujukan.kode;
      this.jenisPelayanan = val.rujukan.pelayanan.kode;
      this.diagnosaAwal = val.rujukan.diagnosa.kode;
      this.poliTujuan = val.rujukan.poliRujukan.kode;
      this.jenisPelayanan = val.rujukan.pelayanan.kode;
      this.asalRujukan = val.asalFaskes;
      this.noKartu = val.rujukan.peserta.noKartu;
      this.kelas = val.rujukan.peserta.hakKelas.kode;
      this.noRujukan = val.rujukan.noKunjungan;
      this.tglRujukan = val.rujukan.tglKunjungan;
      this.nama = val.rujukan.peserta.nama;
      this.telp = val.rujukan.peserta.mr.noTelepon;
      this.cm = val.rujukan.peserta.mr.noMR;
    } else {
      this.clear();
    }
  }

  @Watch("sep")
  cekSEP(val) {
    this.cm = val.noMr;
    this.asalRujukan = val.rujukan.asalRujukan;
    this.ppkRujukan = val.rujukan.ppkRujukan;
    this.diagnosaAwal = val.diagAwal;
    this.poliTujuan = val.poli.tujuan;
    this.dpjpSep = val.dpjpLayan;
    this.skdpspri = val.skdp.noSurat;
    this.dpjpSkdpSpri = val.skdp.kodeDPJP;
    this.jenisPelayanan = val.jnsPelayanan;
    this.kelas = val.klsRawat.klsRawatHak;
    this.naik = val.klsRawat.klsRawatNaik;
    this.pembiayaan = val.klsRawat.pembiayaan;
    this.pjNaikKelas = val.klsRawat.penanggungJawab;
    this.eksekutif = val.poli.eksekutif;
    this.cob = val.cob;
    this.katarak = val.katarak;
    this.catatan = val.catatan;
    this.tglRujukan = val.rujukan.tglRujukan;
    this.tglSEP = val.tglSep;
    this.saving = false;
    this.noKartu = val.noKartu;
    this.noRujukan = val.rujukan.noRujukan;
    this.tujuan = val.tujuanKunj;
    this.flagProsedur = val.flagProcedure;
    this.penunjang = val.kdPenunjang;
    this.asesmen = val.assesmentPel;
    this.kll = val.jaminan.lakaLantas;
    this.tglKll = val.jaminan.penjamin.tglKejadian;
    this.keterangan = val.jaminan.penjamin.keterangan;
    this.suplesi = val.jaminan.penjamin.suplesi.suplesi;
    this.noSEPSuplesi = val.jaminan.penjamin.suplesi.noSepSuplesi;
    this.prov = val.jaminan.penjamin.suplesi.lokasiLaka.kdPropinsi;
    this.kab = val.jaminan.penjamin.suplesi.lokasiLaka.kdKabupaten;
    this.kec = val.jaminan.penjamin.suplesi.lokasiLaka.kdKecamatan;
    this.noSEP = val.noSep;
    this.telp = val.noTelp;
  }

  @Watch("flagProsedur")
  togglePenunjangItemsByProsedur(val) {
    if (val == "0") {
      this.enabledPenunjangItem = ["7", "8", "9", "10", "11"];
    } else {
      this.enabledPenunjangItem = ["1", "2", "3", "4", "5", "6", "12"];
    }

    this.penunjang = "";
  }

  @Watch("kll")
  changedKll(val) {
    if (val <= "0") {
      this.clearKllFields();
    }
  }

  clearKllFields() {
    this.tglKll = "";
    this.keterangan = "";
    this.suplesi = "";
    this.noSEPSuplesi = "";
    this.prov = "";
    this.kab = "";
    this.kec = "";
  }

  clear() {
    this.showPJNaikKelas = true;
    this.cm = "";
    this.telp = "";
    this.asalRujukan = "";
    this.ppkRujukan = "";
    this.diagnosaAwal = "";
    this.poliTujuan = "";
    this.dpjpSep = "";
    this.skdpspri = "";
    this.dpjpSkdpSpri = "";
    this.jenisPelayanan = "";
    this.kelas = "";
    this.naik = "";
    this.pembiayaan = "";
    this.pjNaikKelas = "";
    this.eksekutif = "0";
    this.cob = "0";
    this.katarak = "0";
    this.catatan = "";
    this.tglRujukan = "";
    this.tglSEP = "";
    this.saving = false;
    this.noKartu = "";
    this.noRujukan = "";
    this.tujuan = "0";
    this.flagProsedur = "";
    this.penunjang = "";
    this.asesmen = "";
    this.kll = "0";
    this.tglKll = "";
    this.keterangan = "";
    this.suplesi = "";
    this.noSEPSuplesi = "";
    this.prov = "";
    this.kab = "";
    this.kec = "";
    this.noSEP = "";
  }

  tglFormattedMomentjs(val) {
    return val ? moment(val).format("DD MMMM YYYY") : "";
  }

  changeProv() {}
  changeKab() {}

  simpan() {
    if (!this.saving) {
      this.saving = true;
      SEP.create(this.dataSEP)
        .then(resp => {
          if (resp.data.status != 1) {
            alert(resp.data.message);
            appModule.sendErrorAlert(resp.data.message);
          } else {
            // this.clear();
            this.noSEP = resp.data.data.sep.noSep;
            appModule.NoticeDelay("Berhasil Membuat SEP, no sep=" + this.noSEP);
            const param = {
              nomor: this.noKartu,
              tgl_awal: "2022-01-01",
              tgl_akhir: this.today
            };
            storeSEP.act_riwayat_sep(param);
            storeSEP.act_last_riwayat_sep(param);
          }
        })
        .finally(() => {
          this.saving = false;
        });
    }
  }

  ubah() {
    if (!this.saving) {
      this.saving = true;

      SEP.update(this.dataEditSEP)
        .then(resp => {
          if (resp.data.status != 1) {
            appModule.sendErrorAlert(resp.data.message);
          } else {
            appModule.NoticeDelay("Berhasil mengubah SEP");
            const param = {
              nomor: this.noKartu,
              tgl_awal: "2022-01-01",
              tgl_akhir: this.today
            };
            storeSEP.act_riwayat_sep(param);
            storeSEP.act_last_riwayat_sep(param);
          }
        })
        .finally(() => {
          this.saving = false;
        });
    }
  }

  cetak() {
    if (!this.printing) {
      this.printing = true;
      SEP.print(this.noSEP);
      this.printing = false;
    }
  }

  showTglPulangModal() {
    this.tglPulangModalShowed = true;
  }

  closeTglPulangModal() {
    this.tglPulangModalShowed = false;
  }
}
